module.exports = __webpack_public_path__ + "images/emoji/bank.c4d8050f400ec9baf941.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bank.png
// module id = 27IN
// module chunks = 2